import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 160px;
	background: ${colors.white};
	box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
	color: ${colors.grey7};
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0 32px;
	margin-bottom: 32px;
	border-radius: 1px;
`;

export const BlockLabel = styled.div`
	font-size: 11px;
	line-height: 13px;
	margin-bottom: 4px;
	display: flex;
	height: 15px;

	& > div {
		margin-left: 4px;
	}
`;

export const BlockValue = styled.div`
	font-weight: 500;
	font-size: 28px;
	line-height: 35px;
	letter-spacing: 0.3px;
`;

export const Block = styled.div`
	display: flex;
	flex-direction: column;
`;

export const BlockSeparator = styled.div`
	height: 52px;
	width: 1px;
	background: ${({ white }) => (white ? colors.white : colors.grey2)};
`;

export const BlockGroup = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	justify-content: space-between;

	&:last-child > div:first-child {
		margin-right: 24px;
		padding-top: 0;
	}
`;

export const BottomSection = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	align-items: center;

	font-size: 11px;
	color: ${colors.grey5};
	font-style: normal;
	font-weight: 400;
	line-height: 13px;
	letter-spacing: 0px;
	text-align: left;
	padding-top: 26px;

	& > span {
		padding: 0 8px;
		border-right: 1px solid ${colors.grey3};
	}
	& > span:last-child {
		border-right: none;
	}
`;

export const ChartWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: ${({ width }) => width};
	padding-left: 16px;

	&:last-child > div:first-child {
		margin-right: 24px;
		padding-top: 0;
	}
`;

export const VerticalLayoutWrapper = styled.div`
	height: 100px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	flex: 1;
`;

export const BlockValuePercent = styled.span`
	color: ${colors.grey5};
	font-size: 23px;
	font-weight: 400;
	line-height: 31px;
	letter-spacing: 0.3px;
	margin-left: 8px;
`;

export const LegendWrapper = styled.div`
	letter-spacing: 0.3px;
	display: flex;
	flex-direction: column;
	border-radius: 1px;
	color: ${colors.grey8};
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	font-size: 11px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0px;
`;

export const Color = styled.div`
	background: ${({ color }) => color};
	min-width: 16px;
	width: 16px;
	height: 16px;
	border-radius: 100%;
	margin-right: 8px;
`;

export const Title = styled.div`
	margin-right: 8px;
	white-space: nowrap;
	display: flex;

	& span:first-child {
		display: inline-block;
		max-width: 84px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	& span:last-child {
		margin-left: 3px;
	}
`;

export const ColumnWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const IconWrapper = styled.div`
	height: 12px;
	width: 12px;
	display: inline-block;
`;
